import { gql } from '@apollo/client';
import { FileType } from '@jbc-year-end-adj/2024/types';

export type QueryResult = {
  request: Request;
  clientSetting: ClientSetting;
};

type ClientSetting = {
  id: string;
  requestImageUploadSettings: requestImageUploadSettings;
};

type requestImageUploadSettings = {
  socialInsurance: 'none' | 'optional' | 'required';
};

export type Request = {
  id: string;
  profile: {
    id: string;
    socialInsurances: SocialInsurance[];
  };
};

export type SocialInsurance = {
  id: string;
  amount: string;
  name: string;
  nameOfPayer: string;
  insuranceType: string;
  image: FileType;
};

export const SOCIAL_INSURANCES_FRAGMENT = gql`
  fragment SocialInsurances on Profile {
    socialInsurances {
      id
      amount
      image {
        url
        filename
      }
      name
      nameOfPayer
      insuranceType
    }
  }
`;

export const FETCH_SOCIAL_INSURANCES = gql`
  query lifeInsrances {
    clientSetting {
      id
      requestImageUploadSettings {
        socialInsurance
      }
    }
    request {
      id
      profile {
        id
        ...SocialInsurances
      }
    }
  }
  ${SOCIAL_INSURANCES_FRAGMENT}
`;
